import React from 'react';
import { useIntl } from 'react-intl';

import { Button, FormFooter as UIFormFooter, ValidationMessage } from '@xsolla/ui-core';
import { AlertExclamation } from '@xsolla/ui-icons';

import { SpaceBetweenBlock } from '../../../styled';
import { ErrorWrapper, Wrapper } from './styles';

type Props = {
  submitText?: string;
  cancelText?: string;
  onSubmit: () => void;
  onCancel: () => void;
  fetching: boolean;
  submitButtonPalette?: 'action' | 'brand' | 'danger' | 'muted' | 'warning';
  submitButtonType?: 'submit' | 'button';
  error?: boolean;
  disabled?: boolean;
  isModal?: boolean;
};

const FormFooter = ({
  submitText,
  cancelText,
  onSubmit,
  onCancel,
  submitButtonPalette = 'action',
  submitButtonType = 'submit',
  error,
  disabled,
  fetching,
  isModal = false,
  ...rest
}: Props): JSX.Element => {
  const intl = useIntl();

  return (
    <Wrapper {...rest}>
      <UIFormFooter>
        <SpaceBetweenBlock>
          <Button
            look="tertiary"
            palette="muted"
            onClick={onCancel}
            type="button"
            data-test-id="btn-cancel">
            {cancelText || intl.formatMessage({ id: 'button.cancel' })}
          </Button>

          <ErrorWrapper isModal={isModal}>
            {error && (
              <ValidationMessage>
                <AlertExclamation size={24} />
                <span data-test-id="submit-form-error-span">
                  {intl.formatMessage({ id: 'app.error.submit-form' })}
                </span>
              </ValidationMessage>
            )}

            <Button
              type={submitButtonType}
              look="default"
              palette={submitButtonPalette}
              fetching={fetching}
              onClick={onSubmit}
              disabled={disabled}
              data-test-id="btn-submit">
              {submitText || intl.formatMessage({ id: 'button.save-changes' })}
            </Button>
          </ErrorWrapper>
        </SpaceBetweenBlock>
      </UIFormFooter>
    </Wrapper>
  );
};

export default FormFooter;
